module.exports = __webpack_public_path__ + "img/spaceConfig.79694085.svg";